import { useState } from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight, RotateCcw } from "lucide-react";

const CADRES = [
  { id: "institution", label: "École / crèche / halte-garderie" },
  { id: "domicile", label: "À domicile (assmat, auxiliaire parentale…)" },
  { id: "loisirs", label: "Espace récréatif / de loisirs" },
];

const DEFIS = [
  { id: "crises", label: "Gérer les crises et les émotions", slug: "crises-colere-neurosciences" },
  { id: "fondamentaux", label: "Comprendre le cerveau de l'enfant", slug: "neurosciences-fondamentaux" },
  { id: "lien", label: "Créer un lien sécurisant", slug: "attachement-securite-affective" },
  { id: "signaux", label: "Mieux répondre aux signaux de l'enfant", slug: "caregiving-responsif" },
  { id: "jeu", label: "Enrichir le jeu et les activités", slug: "importance-du-jeu" },
  { id: "langage", label: "Soutenir langage et motricité", slug: "langage-motricite" },
  { id: "environnement", label: "Améliorer l'environnement d'accueil", slug: "environnement-sain" },
];

export const CoachReco = ({ formations }) => {
  const [cadre, setCadre] = useState(null);
  const [defi, setDefi] = useState(null);

  const reco = defi ? formations.find((f) => f.slug === DEFIS.find((d) => d.id === defi)?.slug) : null;

  return (
    <div className="card-soft p-8 relative overflow-hidden" data-testid="coach-reco">
      <div className="absolute -top-8 -right-8 h-40 w-40 rounded-full bg-yellow-400/10 blur-2xl pointer-events-none" />
      <div className="flex items-center gap-3 mb-1">
        <div className="grid place-items-center h-11 w-11 rounded-2xl bg-brand-500 text-white"><Compass size={20} strokeWidth={1.75} /></div>
        <h2 className="font-display font-bold text-xl text-slate-900">Votre boussole formation</h2>
      </div>
      <p className="text-sm text-slate-600 mb-5">2 questions, et nous vous recommandons la formation la plus adaptée à votre quotidien.</p>

      {!cadre && (
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-brand-700 mb-3">1/2 — Votre cadre d'accueil ?</div>
          <div className="flex flex-wrap gap-2">
            {CADRES.map((c) => (
              <button key={c.id} data-testid={`coach-cadre-${c.id}`} onClick={() => setCadre(c.id)} className="rounded-full border border-slate-300 px-4 py-2.5 text-sm font-medium text-slate-700 hover:border-brand-500 hover:text-brand-700 transition-colors">
                {c.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {cadre && !defi && (
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-brand-700 mb-3">2/2 — Votre plus grand défi en ce moment ?</div>
          <div className="flex flex-wrap gap-2">
            {DEFIS.map((d) => (
              <button key={d.id} data-testid={`coach-defi-${d.id}`} onClick={() => setDefi(d.id)} className="rounded-full border border-slate-300 px-4 py-2.5 text-sm font-medium text-slate-700 hover:border-brand-500 hover:text-brand-700 transition-colors">
                {d.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {reco && (
        <div className="mt-2 rounded-2xl bg-slate-900 text-white p-6" data-testid="coach-result">
          <div className="text-xs font-bold uppercase tracking-widest text-yellow-400 mb-2">Notre recommandation pour vous</div>
          <div className="font-display font-bold text-lg leading-snug">{reco.title}</div>
          <p className="text-sm text-slate-300 mt-1.5">{reco.subtitle}</p>
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <Link to={`/formations/${reco.slug}`} data-testid="coach-cta" className="btn-primary text-sm">
              Commander cette formation <ArrowRight size={15} strokeWidth={2} />
            </Link>
            <button onClick={() => { setCadre(null); setDefi(null); }} data-testid="coach-restart" className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-white">
              <RotateCcw size={13} /> Recommencer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
